/**
 * Delete
 */

import Config from '../../Config';
import Util from '../../Util';
import ParamInfo from '../ParamInfo';
import Delete from '../Delete';

class ListDelete extends Delete {

	protected paramInfo: any;

	protected articleId: string;

	protected selector: string;

	constructor( guid: string ) {
		super( guid );
	}

	protected init() {
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();
		this.articleId = '';
		this.selector = '.ncCommunityBoardList .delete';
		this.show();
		this.addEvent();
	}

	protected addEvent() {
		jQuery( 'body' ).on( 'click', this.selector, ( evt ) => {
			evt.preventDefault();

			const _$this = jQuery( evt.currentTarget );
			this.articleId = _$this.attr( 'data-articleid' );

			Config.confirm( Config.L10N.alert_delete_article, () => {
				this.deleteArticle( ( bool: boolean ) => {
					if ( bool ) {
						location.href = Config.listPage + '?' + this.paramInfo.getParamIgnore( 'articleId' );
					} else {
						Config.alert( Config.L10N.alert_retry );
					}
				});
			}, () => {
				// reject
			});
		});
	}
}

export default ListDelete;
